/**
 * VenueFlow ID Utilities
 * 
 * Generates unique identifiers for:
 * - Upload sessions (isolation)
 * - Submission time IDs (filename prefixes)
 */

// ============================================================
// CROCKFORD BASE32 TIME ID
// ============================================================
const CROCKFORD = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";

export function generateCrockfordTimeId() {
  const bytes = crypto.getRandomValues(new Uint8Array(7)); // 7-char ID
  let out = "";

  for (let i = 0; i < bytes.length; i++) {
    out += CROCKFORD[bytes[i] & 31];
  }

  return out;
}

// ============================================================
// SESSION ID
// ============================================================
export function generateSessionId() {
  return `session_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
}

// ============================================================
// FILE ID (for tracking uploads)
// ============================================================
export function generateFileId(uploadId, prefixedFileName) {
  return `${uploadId}::${prefixedFileName}`;
}

const idGenerator = {
  generateCrockfordTimeId,
  generateSessionId,
  generateFileId,
};

export default idGenerator;
